module.exports = __webpack_public_path__ + "static/beginningOfLastMovement-e5d903cd06d2ba7d312c9029d7d66221.mp3";